export default "__VITE_ASSET__BfvpNiJg__"